<div class="suivi-grid">
  <section class="ticket-panel" aria-label="État des tickets" [attr.aria-busy]="chargement()">
    <h3 class="ticket-panel-title">Tickets</h3>

    @if (chargement()) {
      <p class="ticket-empty" role="status">Chargement des tickets...</p>
    } @else if (erreurTickets()) {
      <p class="ticket-empty" role="status">
        Tickets indisponibles.
        <button type="button" class="reessayer" (click)="reessayerTickets()">Réessayer</button>
      </p>
    } @else if (tickets().length === 0) {
      <p class="ticket-empty">Aucun ticket.</p>
    } @else {
      <ul class="ticket-grid">
        @for (ticket of tickets(); track ticket.label) {
          <li>
            <a
              [class]="'ticket-card ticket-card-' + ticket.etat"
              [routerLink]="['/installation', installationId(), 'tickets']"
              [attr.aria-label]="
                ticket.label + ' : ' + ticket.count + ' tickets. Voir les tickets de l’installation'
              "
            >
              <span class="ticket-dot" aria-hidden="true"></span>
              <span class="ticket-card-label">{{ ticket.label }}</span>
              <span class="ticket-card-count">{{ ticket.count }}</span>
            </a>
          </li>
        }
      </ul>
    }
  </section>

  <section
    class="interventions-panel"
    aria-label="État des interventions"
    [attr.aria-busy]="chargementInterventions()"
  >
    <h3 class="ticket-panel-title">Interventions</h3>
    <dl class="interventions-grid">
      <div class="intervention-card intervention-planifiee">
        <dt><span class="ticket-dot" aria-hidden="true"></span>Planifiées</dt>
        <dd class="ticket-card-count">
          {{ chargementInterventions() ? '…' : (compteursInterventions()?.planifiees ?? '—') }}
        </dd>
      </div>
      <div class="intervention-card intervention-cloturee">
        <dt><span class="ticket-dot" aria-hidden="true"></span>Clôturées</dt>
        <dd class="ticket-card-count">
          {{ chargementInterventions() ? '…' : (compteursInterventions()?.cloturees ?? '—') }}
        </dd>
      </div>
    </dl>
    @if (erreurInterventions()) {
      <p class="interventions-erreur" role="status">
        Interventions indisponibles.
        <button
          type="button"
          class="reessayer reessayer-interventions"
          (click)="reessayerInterventions()"
        >
          Réessayer
        </button>
      </p>
    }
  </section>
</div>
